// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, Typography } from '@mui/material';
import { fmt } from '../utils/common';

interface DetailsRowProps {
  label: string;
  value: string | React.ReactNode | null;
  isNumber?: boolean;
}
const commonSx = {
  flex: 2,
  ml: 'auto',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
};
export const DetailsRow = ({ label, value, isNumber }: DetailsRowProps) => {
  const details =
    typeof value === 'string' || typeof value === 'number' ? (
      <Typography variant="body2" sx={commonSx}>
        {isNumber && typeof value === 'string' ? fmt(value, 2) : value}
      </Typography>
    ) : (
      <Box sx={commonSx}>{value}</Box>
    );
  return (
    <Box sx={{ mt: 1, display: 'flex', flexDirection: 'row' }}>
      <Typography sx={{ textTransform: 'capitalize', flex: 1, mr: 1 }} variant="body2">
        {label}
      </Typography>
      {details}
    </Box>
  );
};
